import { useEffect, useRef, useState } from "react";

import { firestore } from "../../../init/firebase";
import { AppResource } from "../../../types/resource.types";

export const useIsValidAdRecord = (recordId: string, resourceName: string) => {
  const [adRecord, setAdRecord] = useState<any>(null);
  const [isValidAdRecord, setIsValidAdRecord] = useState(true);
  const [error, setError] = useState<string>("");

  const timerId = useRef<any>();

  useEffect(() => {
    timerId.current = setTimeout(async () => {
      try {
        if (!recordId) {
          setIsValidAdRecord(true);
          setAdRecord(null);
          setError("");
          return;
        }

        const snapshot = await firestore.collection(resourceName).doc(recordId).get();
        if (snapshot.exists) {
          setAdRecord(snapshot.data());
          setIsValidAdRecord(true);
          setError("");
        } else {
          setAdRecord(null);
          setIsValidAdRecord(false);
          setError(
            `${
              resourceName === AppResource.sportsClubs
                ? "Sports club"
                : resourceName === AppResource.brands
                ? "brand"
                : "place"
            } not found, validate the provided id`
          );
        }
      } catch (ex: any) {
        console.log(ex.message);
        setIsValidAdRecord(false);
        setError(
          `Error on check ${
            resourceName === AppResource.sportsClubs
              ? "sports club"
              : resourceName === AppResource.brands
              ? "brand"
              : "place"
          }`
        );
      }
    }, 500);

    return () => {
      timerId.current = null;
    };
  }, [recordId]);

  return {
    isValidAdRecord,
    error,
    adRecord,
    adDeepUrl: recordId ? `/${resourceName}/${recordId}` : "",
  };
};

export const useIsValidExternalLink = (link: string) => {
  const [isValidExternalLink, setIsValidExternalLink] = useState(true);
  const [error, setError] = useState<string>("");

  const timerId = useRef<any>();

  useEffect(() => {
    timerId.current = setTimeout(async () => {
      const linkRegex =
        /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
      if (link && !linkRegex.test(link)) {
        setIsValidExternalLink(false);
        setError("Invalid url");
      } else {
        setIsValidExternalLink(true);
        setError("");
      }
    }, 500);

    return () => {
      timerId.current = null;
    };
  }, [link]);

  return { isValidExternalLink, error };
};
